// src/components/Header.js
import React from "react";
import { FaBars } from "react-icons/fa";
import "./Header.css";

const Header = ({ toggleSidebar }) => {
  return (
    <div className="header">
      <button className="toggle-btn" onClick={toggleSidebar}>
        <FaBars />
      </button>
      <div className="user-section">
        <span>Welcome, Admin</span>
      </div>
    </div>
  );
};

export default Header;
